module.exports = __webpack_public_path__ + "img/10.c8cc94cd.gif";